// extracted by mini-css-extract-plugin
export default {"starIcon":"LivePollStarUnStar_starIcon__fN4or","starIconColor":"LivePollStarUnStar_starIconColor__NTSyD"};